import { __assign } from 'tslib';
import React__default from 'react';
import { MasonryViewSize } from '@keepeek/commons';
import { useTheme, Box } from '@mui/material';
import clsx from 'clsx';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import StyledKGrid, { classes } from './index.styled.js';

var KGridMode;
(function (KGridMode) {
    KGridMode["Dataview"] = "DATAVIEW";
    KGridMode["Masonry"] = "MASONRY";
})(KGridMode || (KGridMode = {}));
var KGrid = function (_a) {
    var _b, _c, _d;
    var className = _a.className, id = _a.id, _e = _a.testId, testId = _e === void 0 ? "elementsGrid" : _e, children = _a.children, sx = _a.sx, _f = _a.mode, mode = _f === void 0 ? KGridMode.Dataview : _f, _g = _a.masonryViewSize, masonryViewSize = _g === void 0 ? MasonryViewSize.Small : _g;
    var theme = useTheme();
    var columnsCountBreakPoints = {};
    switch (masonryViewSize) {
        case MasonryViewSize.Small:
            columnsCountBreakPoints = (_b = {},
                _b[theme.breakpoints.values.xs] = 2,
                _b[theme.breakpoints.values.sm] = 4,
                _b[theme.breakpoints.values.md] = 5,
                _b[theme.breakpoints.values.lg] = 6,
                _b);
            break;
        case MasonryViewSize.Medium:
            columnsCountBreakPoints = __assign(__assign({}, columnsCountBreakPoints), (_c = {}, _c[theme.breakpoints.values.xs] = 2, _c[theme.breakpoints.values.sm] = 3, _c[theme.breakpoints.values.md] = 3, _c[theme.breakpoints.values.lg] = 4, _c));
            break;
        case MasonryViewSize.Large:
            columnsCountBreakPoints = __assign(__assign({}, columnsCountBreakPoints), (_d = {}, _d[theme.breakpoints.values.xs] = 1, _d[theme.breakpoints.values.sm] = 2, _d[theme.breakpoints.values.md] = 2, _d[theme.breakpoints.values.lg] = 3, _d));
            break;
    }
    var grid = function () {
        switch (mode) {
            case KGridMode.Masonry:
                return (React__default.createElement(ResponsiveMasonry, { columnsCountBreakPoints: columnsCountBreakPoints },
                    React__default.createElement(Masonry, { gutter: "10px", style: { listStyleType: "none" } }, children)));
            default:
                return (React__default.createElement(Box, { component: "ol", className: classes.dataview }, children));
        }
    };
    return (React__default.createElement(StyledKGrid, { id: id, "data-testid": testId, className: clsx("KGrid", className), sx: sx }, grid()));
};

export { KGridMode, KGrid as default };
//# sourceMappingURL=index.js.map
